import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@components/shadcn-ui/table";
import { useDynamicHeight } from "@customHooks/useDynamicHeight";
import { Badge } from "@components/shadcn-ui/badge";
import { ApplicationState } from "features/Permission/types";
import {
  APPLICATION_STATUS,
  getProductTypeByValue,
  getStatusColor,
} from "./config";
import { toTitleCase } from "../resourceNotes/utils";
import { ActionButtonWithPersmission } from "./components/ActionButtonWithPersmission";

// Add near top of file (helpers)
const truncateWithTitle = (str?: string, max = 32) => {
  if (!str) return "";
  if (str.length <= max) return <span>{str}</span>;
  const trimmed = str.slice(0, max - 3).trimEnd() + "...";
  // title attribute shows the full name on hover
  return <span title={str} className="inline-block">{trimmed}</span>;
};

export interface ApplicationDetailsInterface {
  id: string;
  leadId: string;
  state: ApplicationState;
  personalDetails: { [key: string]: string };
  kycDetails: { [key: string]: string };
  productType: string;
  loanRequirementDetails: { [key: string]: string };
  loanApprovalDetails?: { [key: string]: string };
  references?: Array<{
    addressId: string;
    relationToApplicant: string;
    personalDetails: {
      firstName: string;
      lastName: string;
      phoneNumber: string;
    };
  }>;
  coApplicantDetails?: {
    personalDetails: {
      firstName: string;
      lastName: string;
      phoneNumber?: string;
      email?: string;
    };
    kycDetails?: {
      panNumber?: string;
    };
    addressId: string[] | string;
    relationToApplicant: string;
  };
  rejectionDetails: {
    rejectReason: string;
    detailedReason: string;
  };
  createdBy: string;
}

export const ApplicationList = ({ applications }: any) => {
  const { ref, height } = useDynamicHeight();
  console.log("Applications >> ", applications);

  return (
    <>
      <div
        className="overflow-auto"
        ref={ref}
        style={{
          height: `${height}px`,
        }}
      >
        <Table>
          <TableHeader className="bg-blue-200">
            <TableRow>
              <TableCell>Application ID</TableCell>
              <TableCell>Created On</TableCell>
              <TableCell>Customer Name</TableCell>
              <TableCell>Product Type</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {applications.map((app: any, index: number) => (
              <TableRow key={index} className="bg-white h-[45px]">
                <TableCell className="py-1">{app.id}</TableCell>
                <TableCell className="py-1">
                  {(() => {
                    const created = new Date(app.createdTime);
                    const dateOnly = created.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    });
                    const full = created.toLocaleString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    });
                    return (
                      <span title={full} className="inline-block whitespace-nowrap">
                        {dateOnly}
                      </span>
                    );
                  })()}
                </TableCell>
                <TableCell className="py-1">
                  {truncateWithTitle(toTitleCase(app.customerName), 32)}
                </TableCell>
                <TableCell className="py-1">
                  {getProductTypeByValue(app.product)}
                </TableCell>
                <TableCell className="py-1">
                  {app.createdBy ? toTitleCase(app.createdBy) : "-"}
                </TableCell>
                <TableCell className="py-1">
                  {/* TODO: Create A separate compoent */}
                  <Badge
                    className={`rounded-sm px-1 font-normal ${getStatusColor(
                      app.state
                    )}`}
                  >
                    {
                      APPLICATION_STATUS[
                        app.state as keyof typeof APPLICATION_STATUS
                      ]
                    }
                  </Badge>
                </TableCell>
                <TableCell className="py-1 flex gap-2">
                  <ActionButtonWithPersmission app={app} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
};
